exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".empty__state[data-v-992932fe]{text-align:center;margin-top:2rem;margin-bottom:6rem}.empty__state img[data-v-992932fe]{margin-bottom:2rem}.empty__state__text[data-v-992932fe]{display:flex;justify-content:center;flex-direction:column;width:45%;margin:auto}.empty__state__text>.empty__state__title[data-v-992932fe]{font-weight:700;font-size:16px;color:var(--dark-gray)}.empty__state__text>.empty__state__subtitle[data-v-992932fe]{font-weight:400;font-size:16px;color:var(--dark-gray)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-992932fe","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/components/layouts/emptyState.vue
// module id = 703
// module chunks = 0